// Map viewport centers for the six standard Booking cities and their aliases.
// Public municipality positions from Mapy.com geocoding, verified 2026-09-15.
// Context only: these points never represent or verify a meeting address.
export const standardCityMapCenters: Record<string, [number, number]> = {
  praha: [50.08355, 14.43414],
  prague: [50.08355, 14.43414],
  brno: [49.20022, 16.60784],
  ostrava: [49.83465, 18.28204],
  olomouc: [49.59257, 17.2496],
  brusel: [50.84674, 4.35249],
  brussels: [50.84674, 4.35249],
  bruxelles: [50.84674, 4.35249],
  london: [51.50745, -0.12777],
  londýn: [51.50745, -0.12777],
};
